import ns from '../api/utilities/namespace.js';

export const DisclosureSelector = {
  PREVENT_CONCEAL: ns.attr.selector('prevent-conceal')
};
